// 数值千分位
function formatAmount(amount) {
    let temp = parseInt(amount);
    let initLen = String(amount).length;
    let numLen = String(temp).length;
    let unitIndex = numLen - initLen;

    let amountArr = temp.toString(10).split('.');
    const _int = amountArr[0].split('');
    let _num = '';
    for (let i = _int.length - 1, j = 1; i >= 0; i--, j++) {
        _num += _int[i];
        if (j % 3 === 0 && j < _int.length) {
            _num += ',';
        }
    }
    _num = _num.split('').reverse().join('');
    
    if (unitIndex < 0) {
        let tail = String(amount).slice(unitIndex);
        _num = `${_num}${tail}`
    }
    return _num;
}

export default {
    formatAmount
}